import { ArrangementTimeline } from '../components/music/ArrangementTimeline';
import { ExportPanel } from '../components/music/ExportPanel';
import { GeneratorPanel } from '../components/music/GeneratorPanel';
import { Mixer } from '../components/music/Mixer';
import { PatternEditor } from '../components/music/PatternEditor';
import { TransportBar } from '../components/music/TransportBar';

export function MusicWorkspace() {
  return (
    <div className="flex flex-col gap-4">
      <TransportBar />
      <ArrangementTimeline />
      <PatternEditor />
      <Mixer />
      <GeneratorPanel />
      <ExportPanel />
    </div>
  );
}
